import { CustomDataSource, Color, PolylineGlowMaterialProperty } from 'cesium';
import LineFlowMaterialProperty from './LineFlowMaterialProperty';
import { transformGeometry } from '../feature-layer/createFeatureCollection';
import { isString, isObject, isArray } from 'lodash';
import transformRgb from '../_util/transformRgb';
import parabola from '../_util/parabola';

const getCoordinates = geometryInfo => {
    if (geometryInfo) {
        if (isString(geometryInfo)) {
            const [start, end, z] = geometryInfo.split(',');

            return [Number(start), Number(end), Number(z || 0)];
        } else if (isArray(geometryInfo)) {
            const [start, end, z] = geometryInfo;

            return [Number(start), Number(end), Number(z || 0)];
        } else if (isObject(geometryInfo)) {
            if (geometryInfo.geometryInfo) {
                return getCoordinates(geometryInfo.geometryInfo);
            }

            let [start, end, z] = transformGeometry(geometryInfo).coordinates;

            return [Number(start), Number(end), Number(z || 0)];
        }
    }
};
export default class FlyLineLayer extends CustomDataSource {
    constructor(option) {
        const {
            data,
            key,
            labelField,
            template,
            height,
            count,
            color,
            speed,
            width,
            opacity = 0.3,
            flyWidth,
            name,
            layerControl,
            show = true,
            map,
            number = 1,
            glowPower,
        } = option;

        super(option);
        super.show = show;
        // 图层标识
        this.key = key;

        // 图层名称
        this.name = name;

        // 标签字段
        this.labelField = labelField;

        // 模版内容
        this.template = template;

        this.data = data;

        // 颜色
        this.color = color || '#0080ff';

        // 高度
        this.height = height;

        // 数量
        this.count = count || 1;

        // 速度
        this.speed = speed || 10;

        // 轨迹线宽度
        this.width = width || 1;

        // 飞线数量
        this.number = number || 1;

        // 发光强度
        this.glowPower = glowPower || 0;

        // 轨迹颜色透明度
        this.opacity = opacity || 0.3;
        // 地图
        this.map = map;
        // 飞线宽度
        this.flyWidth = flyWidth || 3;
        this.layerControl = layerControl;
        if (data?.length) {
            this.loadData(data);
        }
    }
    // 重写父类的属性访问器
    get show() {
        return super.show;
    }

    set show(value) {
        this.setVisible(value);
    }

    // 获取地图
    getMap() {
        return this.map;
    }

    // 设置图层显示隐藏
    setVisible(visible) {
        super.show = visible; // 将属性传递给父类

        const map = this.getMap && this.getMap();
        if (map) {
            map.layers.emit('visible', this, visible);
        }
    }

    loadData(data) {
        this.entities.removeAll();

        data.map(v => {
            let height = this.height || 0;
            let count = this.count;
            let color = this.color;

            let startPosition = [],
                endPosition = [];
            if (isArray(v)) {
                startPosition = v[0];
                endPosition = v[1];
            } else {
                let { start, end } = v;
                height = v.height || height;
                count = v.count || count;
                color = v.color || color;

                startPosition = getCoordinates(start);
                endPosition = getCoordinates(end);
            }

            let positions = parabola({
                startPosition,
                endPosition,
                height,
                count,
            });

            // 创建飞线
            for (let i = 0; i < this.number; i++) {
                // 创建飞线
                const entity_fly = this.entities.add({
                    polyline: {
                        positions,
                        width: this.flyWidth,
                        material: new LineFlowMaterialProperty({
                            color: Color.fromCssColorString(color),
                            speed: this.speed * Math.random(),
                            percent: 0.1,
                            gradient: 0.01,
                        }),
                    },
                });

                entity_fly.type = this.modalType || this.key;
                entity_fly.key = this.key;
                // 处理图层搜索的时候出现重复数据的问题
                entity_fly.ignoreSearch = true;
                entity_fly.properties = v.properties || {};
            }

            let material = this.glowPower
                ? new PolylineGlowMaterialProperty({
                      glowPower: this.glowPower, // 发光强度
                      color: Color.fromCssColorString(transformRgb(color, this.opacity)),
                  })
                : Color.fromCssColorString(transformRgb(color, this.opacity));

            // 创建轨迹线
            const entity = this.entities.add({
                polyline: {
                    positions,
                    width: this.width,
                    material,
                },
            });

            entity.type = this.modalType || this.key;
            entity.key = this.key;
            entity.properties = v.properties || {};
        });
    }

    // 根据条件获取图形数据
    getFeatureByFieldValue(field, value) {
        return this.getFeatures().find(v => v?.properties?.[field]?._value === value);
    }

    // 获取当前图层的所有图形
    getFeatures() {
        return this.entities.values;
    }
}
